export const _setBuildingForm = (state, action) => action.payload;

export const _setIsNewBuilding = (state, action) => {
  state.isNewBuilding = action.payload;
};

export const _setBuilding = (state, action) => {
  state.building = action.payload;
};
